import { jsx as s, jsxs as G } from "react/jsx-runtime";
import { forwardRef as P, useState as S, useRef as p, useImperativeHandle as W, useEffect as E, useLayoutEffect as N } from "react";
import { createPortal as Y } from "react-dom";
import { useBreakpoint as A } from "./components/Breakpoint/BreakpointProvider.js";
import { d as z } from "./DropDownMLP1.module-6873bd01.mjs";
import { d as C } from "./DropDownMLP2.module-e5bfca51.mjs";
import { getContainerPortalId as L } from "./utils/index.js";
import { DEFAULT_PORTAL_CONTAINER_ID as I } from "./types/enums.js";
import M from "./hooks/useClickOutsideDetector.js";
import "./components/Modal/types/enums.js";
import './assets/RawModal.css';const D = "#ffffff", H = "#396e75", T = "#e5fdff", j = "#546223", q = "#f0fae5", F = "#a65523", U = "#fff1e8", J = "#7f3e3e", K = "#ffe2e2", Q = "#62625a", X = "#f8f8e7", Z = "#38539a", tt = "#707070", at = "#c8f8d1", ot = "#87c9c8", et = "#5291b1", nt = "rgba(82, 145, 177, 0.1019607843)", rt = "#445685", it = "#181d61", dt = "rgba(24, 29, 97, 0.1019607843)", lt = "#5969d6", ct = "#ea999d", st = "#b6577e", _t = "rgba(182, 87, 126, 0.1019607843)", yt = "#7e3e80", mt = "#1e247f", kt = "rgba(30, 36, 127, 0.1019607843)", ut = "#da7600", ft = "#107f47", gt = "#d91734", ht = "_html_k9ynx_75", V = {
  amwayWhite: D,
  darkBlue: H,
  lightBlue: T,
  darkGreen: j,
  lightGreen: q,
  darkOrange: F,
  lightOrange: U,
  darkRed: J,
  lightRed: K,
  darkYellow: Q,
  lightYellow: X,
  darkPurple: Z,
  darkGrayOnWhite: tt,
  dataVizColor1: at,
  dataVizColor2: ot,
  dataVizColor3: et,
  dataVizColor3Background: nt,
  dataVizColor4: rt,
  dataVizColor5: it,
  dataVizColor5Background: dt,
  dataVizColor6: lt,
  dataVizColor7: ct,
  dataVizColor8: st,
  dataVizColor8Background: _t,
  dataVizColor9: yt,
  dataVizColor10: mt,
  dataVizColor10Background: kt,
  dataVizAlertOrange: ut,
  dataVizSuccessGreen: ft,
  dataVizWarningRed: gt,
  "no-visible": "_no-visible_k9ynx_34",
  html: ht,
  "date-picker-container": "_date-picker-container_k9ynx_142",
  "date-picker-container-within-modal": "_date-picker-container-within-modal_k9ynx_143",
  "input-label": "_input-label_k9ynx_147",
  "date-picker-tool-tip": "_date-picker-tool-tip_k9ynx_162",
  "required-indicator": "_required-indicator_k9ynx_169",
  "icon-close": "_icon-close_k9ynx_173",
  "menu-container": "_menu-container_k9ynx_180",
  "default-width": "_default-width_k9ynx_195",
  "full-width": "_full-width_k9ynx_200",
  "within-drawer": "_within-drawer_k9ynx_200",
  "calendar-header": "_calendar-header_k9ynx_210",
  "calendar-header-title": "_calendar-header-title_k9ynx_220",
  "description-container": "_description-container_k9ynx_238",
  "calendar-body": "_calendar-body_k9ynx_248",
  "datepicker-modal-header-section": "_datepicker-modal-header-section_k9ynx_252",
  "modal-icon-section": "_modal-icon-section_k9ynx_262",
  "modal-headline": "_modal-headline_k9ynx_266",
  "input-container": "_input-container_k9ynx_270",
  "datepicker-default": "_datepicker-default_k9ynx_285",
  "input-container-active": "_input-container-active_k9ynx_290",
  "calendar-modal-container": "_calendar-modal-container_k9ynx_300",
  "datepicker-valid": "_datepicker-valid_k9ynx_304",
  "datepicker-invalid": "_datepicker-invalid_k9ynx_309",
  "datepicker-input-disabled": "_datepicker-input-disabled_k9ynx_314",
  "placeholder-container": "_placeholder-container_k9ynx_322",
  "action-button-container": "_action-button-container_k9ynx_339",
  "action-button": "_action-button_k9ynx_339",
  "primary-action-button": "_primary-action-button_k9ynx_357",
  "modal-action-button-container": "_modal-action-button-container_k9ynx_361",
  "datePicker-modal-description-container": "_datePicker-modal-description-container_k9ynx_366",
  "calendar-icon": "_calendar-icon_k9ynx_381",
  "calendar-wrapper": "_calendar-wrapper_k9ynx_386",
  "calendar-footer": "_calendar-footer_k9ynx_392",
  "calendar-heading": "_calendar-heading_k9ynx_399"
}, pt = "#ffffff", zt = "#396e75", Ct = "#e5fdff", Vt = "#546223", wt = "#f0fae5", bt = "#a65523", $t = "#fff1e8", xt = "#7f3e3e", Bt = "#ffe2e2", Rt = "#62625a", vt = "#f8f8e7", Ot = "#38539a", Gt = "#707070", Pt = "#c8f8d1", St = "#87c9c8", Wt = "#5291b1", Et = "rgba(82, 145, 177, 0.1019607843)", Nt = "#445685", Yt = "#181d61", At = "rgba(24, 29, 97, 0.1019607843)", Lt = "#5969d6", It = "#ea999d", Mt = "#b6577e", Dt = "rgba(182, 87, 126, 0.1019607843)", Ht = "#7e3e80", Tt = "#1e247f", jt = "rgba(30, 36, 127, 0.1019607843)", qt = "#da7600", Ft = "#107f47", Ut = "#d91734", Jt = "_html_1yry0_75", r = {
  amwayWhite: pt,
  darkBlue: zt,
  lightBlue: Ct,
  darkGreen: Vt,
  lightGreen: wt,
  darkOrange: bt,
  lightOrange: $t,
  darkRed: xt,
  lightRed: Bt,
  darkYellow: Rt,
  lightYellow: vt,
  darkPurple: Ot,
  darkGrayOnWhite: Gt,
  dataVizColor1: Pt,
  dataVizColor2: St,
  dataVizColor3: Wt,
  dataVizColor3Background: Et,
  dataVizColor4: Nt,
  dataVizColor5: Yt,
  dataVizColor5Background: At,
  dataVizColor6: Lt,
  dataVizColor7: It,
  dataVizColor8: Mt,
  dataVizColor8Background: Dt,
  dataVizColor9: Ht,
  dataVizColor10: Tt,
  dataVizColor10Background: jt,
  dataVizAlertOrange: qt,
  dataVizSuccessGreen: Ft,
  dataVizWarningRed: Ut,
  "no-visible": "_no-visible_1yry0_34",
  html: Jt,
  "modal-container": "_modal-container_1yry0_142",
  "modal-dialog": "_modal-dialog_1yry0_146",
  "close-icon": "_close-icon_1yry0_184",
  "modal-headline": "_modal-headline_1yry0_189",
  "modal-headline-left": "_modal-headline-left_1yry0_198",
  "modal-headline-center": "_modal-headline-center_1yry0_201",
  "modal-content-center": "_modal-content-center_1yry0_204",
  "modal-content-left": "_modal-content-left_1yry0_226",
  "modal-header-section": "_modal-header-section_1yry0_248",
  "modal-icon-section": "_modal-icon-section_1yry0_255",
  "modal-footer-section": "_modal-footer-section_1yry0_270",
  "modal-bottom-container": "_modal-bottom-container_1yry0_280",
  "modal-bottom-without-secondary": "_modal-bottom-without-secondary_1yry0_289",
  "bottom-container": "_bottom-container_1yry0_298",
  "modal-button-container": "_modal-button-container_1yry0_308",
  "align-horizontal-button": "_align-horizontal-button_1yry0_315",
  "align-vertical-button": "_align-vertical-button_1yry0_315",
  "text-link": "_text-link_1yry0_323",
  "modal-content": "_modal-content_1yry0_204",
  "align-default-button": "_align-default-button_1yry0_367",
  "primary-button-with-textlink": "_primary-button-with-textlink_1yry0_374"
};
function k(o, i, d, _) {
  const l = Array.from(
    o.current.getElementsByClassName(i)
  ), t = Array.from(
    o.current.getElementsByClassName(d)
  );
  t != null && t.length && l.forEach((c, a) => {
    if (t != null && t[a]) {
      const e = c.getBoundingClientRect();
      _ ? (t[a].style.left = `${e.left - o.current.getBoundingClientRect().left}px`, t[a].style.margin = "0") : t[a].style.left = "unset", t[a].style.top = `${e.top - o.current.getBoundingClientRect().top + e.height + 8}px`, t[a].style.right = "unset", t[a].style.position = "fixed", t[a].style.width = `${e.width}px`;
    }
  });
}
const Kt = P(
  ({
    header: o,
    children: i,
    containerWidth: d,
    textAlign: _,
    closeOnBackdropClick: l = !0,
    onClose: t,
    id: c,
    footer: a,
    className: e,
    footerClassname: w,
    useReactPortal: b = !1,
    portalContainerId: $ = I
  }, x) => {
    const [B, R] = S(!1), n = p(), u = p(), v = A();
    W(x, () => n.current);
    const O = (() => l ? t : void 0)();
    M(n, O, [l], u);
    function y() {
      const m = document.getElementById(`nextgen-modal-content-${c}`);
      m && R(m.scrollHeight > Math.ceil(m.getBoundingClientRect().height));
    }
    E(() => (y(), window.addEventListener("resize", y), () => window.removeEventListener("resize", y)), [i]), N(() => {
      k(
        n,
        C["mlp-2-dropdown-modal"],
        C["dropdown-drawer"],
        !1
      ), k(
        n,
        z["dropdown-container-modal"],
        z["base-dropdown-result"],
        !1
      ), k(
        n,
        V["date-picker-container-within-modal"],
        V["menu-container"],
        !0
      );
    }, [v]);
    let f = r["modal-bottom-without-secondary"];
    B && (f += ` ${r["bottom-container"]}`);
    const g = /* @__PURE__ */ s("div", { ref: u, "data-testid": "modal-container-data-testid", "data-pod-name": "fwk", children: /* @__PURE__ */ s("section", { className: r["modal-dialog"], children: /* @__PURE__ */ G(
      "section",
      {
        className: `${r["modal-container"]} ${e}`,
        style: d ? { width: d } : {},
        ref: n,
        children: [
          o,
          /* @__PURE__ */ s(
            "section",
            {
              id: `nextgen-modal-content-${c}`,
              className: r[`modal-content-${_}`],
              "data-testid": "content-test-id",
              "data-pod-name": "fwk",
              children: i
            }
          ),
          /* @__PURE__ */ s("section", { className: `${f} ${w}`, children: a })
        ]
      }
    ) }) }), h = L($);
    return b && h ? Y(g, h) : g;
  }
);
Kt.displayName = "RawModal";
export {
  Kt as R,
  V as a,
  r as s
};
//# sourceMappingURL=RawModal-4c2e39d2.mjs.map
